const ItalicIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M22 1v2h-5v1h-1v2h-1v2h-1v3h-1v2h-1v3h-1v2h-1v2H9v1h7v2H2v-2h5v-1h1v-2h1v-2h1v-3h1v-2h1V8h1V6h1V4h1V3H8V1z"
      />
    </svg>
  );
};

export default ItalicIcon;
